import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteRuleTitle: {
		id: 'servicedesk.automation.summary.rule-list.rule.delete-dialog.delete-rule-title',
		defaultMessage: 'Delete rule',
		description: '',
	},
	deleteRuleMessage: {
		id: 'servicedesk.automation.summary.rule-list.rule.delete-dialog.delete-rule-message',

		defaultMessage:
			'Just a warning that if you delete this rule it will stop running right away and cannot be recovered if you change your mind.',

		description: '',
	},
});
